(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-drop-content') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            --drop-content-bg: white;
            --drop-content-max-width: 240px;
            --drop-content-max-height: 160px;
            --drop-content-transition-duration: .125s;
            --drop-content-transition-timing-function: ease;
            --drop-content-transition: opacity var(--drop-content-transition-duration) var(--drop-content-transition-timing-function);
            --drop-content-padding: 1em;
            --drop-content-shadow: 0 0 .2em rgba(0, 0, 0, .25);
            --drop-content-tip-size: 1em;
            /* can be used for animations */
            --drop-content-current-content-height: 0px;
        
            --drop-content-internal-wrap-flow: column;
            --drop-content-internal-wrap-align: center;
            --drop-content-internal-wrap-justify: center;
            --drop-content-internal-tip-rotate: 0deg;
            --drop-content-internal-tip-margin-v: 0;
            --drop-content-internal-tip-margin-h: var(--drop-content-padding);
            --drop-content-internal-transform-x: 0;
            --drop-content-internal-transform-y: 0;
        
            display: none;
            opacity: 0;
            transition: var(--drop-content-transition);
            filter: drop-shadow(var(--drop-content-shadow));
            transform: translateX(var(--drop-content-internal-transform-x)) translateY(var(--drop-content-internal-transform-y));
        }
        [part="wrap"] {
            display: flex;
            flex-direction: var(--drop-content-internal-wrap-flow);
            align-items: var(--drop-content-internal-wrap-align);
            justify-content: var(--drop-content-internal-wrap-justify);
        }
        [part="content"] {
            position: relative;
            background: var(--drop-content-bg);
            padding: var(--drop-content-padding);
            flex-grow: 1;
        }
        [part="tip"] {
            position: relative;
            color: var(--drop-content-bg);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            transform-origin: center center;
            transform: rotate(var(--drop-content-internal-tip-rotate));
            width: var(--drop-content-tip-size);
            height: var(--drop-content-tip-size);
            min-width: var(--drop-content-tip-size);
            min-height: var(--drop-content-tip-size);
            margin: var(--drop-content-internal-tip-margin-v) var(--drop-content-internal-tip-margin-h);
            flex-grow: 0;
        }
        :host(:not([show-tip])) [part="tip"] {
            display: none;
        }
        [part="default-tip"] {
            width: 0;
            height: 0;
            border-left: calc(var(--drop-content-tip-size) / 2) solid transparent;
            border-right: calc(var(--drop-content-tip-size) / 2) solid transparent;
            border-top: var(--drop-content-tip-size) solid var(--drop-content-bg);
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: calc(var(--drop-content-tip-size) / 2 * -1);
        }
        
        /* default open state */
        :host([open]) {
            display: block;
            opacity: 1;
            position: absolute;
            z-index: 101;
        }
        
        /* vertical positioning and flow */
        :host([open*="above"]) {
            bottom: 100%;
        }
        :host([open*="above"][open*="down"]) {
            top: 0;
            bottom: auto;
        }
        :host([open*="beside"]) {
            top: 0;
        }
        :host([open*="beside"][open*="up"]) {
            bottom: 0;
            top: auto;
        }
        :host([open*="beside"][open*="middle"]) {
            top: 50%;
            bottom: auto;
            --drop-content-internal-transform-y: -50%;
        }
        :host([open*="below"]) {
            top: 100%;
        }
        :host([open*="below"][open*="up"]) {
            bottom: 0;
            top: auto;
        }
        
        /* horizontal positioning */
        :host([open*="from-center"]) {
            left: 50%;
            right: auto;
            --drop-content-internal-transform-x: -50%;
        }
        :host([open*="from-center"][open*="to-left"]) {
            --drop-content-internal-transform-x: -100%;
        }
        :host([open*="from-center"][open*="to-right"]) {
            --drop-content-internal-transform-x: 0;
        }
        :host([open*="from-left"]) {
            left: 0;
        }
        :host([open*="from-left"][open*="to-left"]) {
            right: 100%;
            left: auto;
        }
        :host([open*="from-right"]) {
            right: 0;
        }
        :host([open*="from-right"][open*="to-right"]) {
            left: 100%;
            right: auto;
        }
        
        /* tip positions */
        /* rotate tip, re-arrange and flip flex-start / flex-end because the element was rotated */
        :host([open*="below"]) {
            --drop-content-internal-wrap-flow: column-reverse;
            --drop-content-internal-tip-rotate: 180deg;
        }
        :host([open*="beside"]) {
            --drop-content-internal-wrap-flow: row-reverse;
            --drop-content-internal-tip-rotate: 90deg;
            --drop-content-internal-tip-margin-h: 0;
            --drop-content-internal-tip-margin-v: var(--drop-content-padding);
        }
        
        :host([open*="from-left"]) {
            --drop-content-internal-wrap-align: flex-start;
        }
        :host([open*="from-left"][open*="to-left"]) {
            --drop-content-internal-wrap-align: flex-end;
        }
        :host([open*="from-right"]) {
            --drop-content-internal-wrap-align: flex-end;
        }
        :host([open*="from-right"][open*="to-right"]) {
            --drop-content-internal-wrap-align: flex-start;
        }
        :host([open*="beside"][open*="from-left"][open*="to-left"]) {
            --drop-content-internal-wrap-flow: row;
            --drop-content-internal-tip-rotate: -90deg;
        }
        </style>
        <div part="wrap">
            <div part="content">
                <slot></slot>
            </div>
            <div part="tip">
                <div slot="tip">
                    <span part="default-tip"></span>
                </div>
            </div>
        </div>
        `;
        /**
         * @todo there should be a way to calculate the ideal position more easily
         */
        customElements.define('base-drop-content', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this._boundaryElement = null;
            }
            get preferred() {
                const text = this.getAttribute('preferred')  || 'above from-center';
                const tmp = document.createElement('span');
                tmp.className = text.replace(/\s+/g, ' ', text);
                return tmp.classList;
            }
            get boundary() {
                return this._boundaryElement ? this._boundaryElement.getBoundingClientRect() : null;
            }
            set boundary(node) {
                if (node instanceof Element) {
                    this._boundaryElement = node;
                }
            }
            toggle() {
                if (this.hasAttribute('open')) {
                    this.close();
                } else {
                    this.open();
                }
            }
            open() {
                if (this.hasAttribute('open')) {
                    return;
                }
                let tokens = this.preferred;
                /* @var DOMtokenList tokens */
                this.setAttribute('open', tokens.toString());
                const rect = this.getBoundingClientRect();
                const bounds = this.boundary;
                const viewPortHeight = window.innerHeight || document.documentElement.clientHeight;
                const viewPortWidth = window.innerWidth || document.documentElement.clientWidth;
                const intersectsTop = rect.top < 0 || (bounds !== null && rect.top < bounds.top);
                const intersectsBottom = rect.bottom > viewPortHeight || (bounds !== null && rect.bottom > bounds.bottom);
                const intersectsLeft = rect.left < 0 || (bounds !== null && rect.left < bounds.left);
                const intersectsRight = rect.right > viewPortWidth || (bounds !== null && rect.right > bounds.right);
                // @todo test custom boundary element
                if (intersectsTop || intersectsBottom) {
                    if (tokens.contains('above') && tokens.contains('down') && intersectsBottom) {
                        tokens.remove('above', 'down');
                        tokens.add('below', 'up');
                    } else if (tokens.contains('above') && intersectsTop) {
                        tokens.remove('above');
                        tokens.add('below', 'down');
                    } else if (tokens.contains('beside') && tokens.contains('middle') && intersectsTop) {
                        tokens.replace('middle', 'down');
                    } else if (tokens.contains('beside') && tokens.contains('middle') && intersectsBottom) {
                        tokens.replace('middle', 'up');
                    } else if (tokens.contains('beside') && tokens.contains('up') && intersectsTop) {
                        tokens.replace('up', 'down');
                    } else if (tokens.contains('beside') && intersectsBottom) {
                        tokens.add('up');
                    } else if (tokens.contains('below') && tokens.contains('up') && intersectsTop) {
                        tokens.replace('up', 'down');
                    } else if (tokens.contains('below') && intersectsBottom) {
                        tokens.remove('below');
                        tokens.add('above', 'up');
                    }
                }
                if (intersectsLeft || intersectsRight) {
                    if (tokens.contains('from-left') && tokens.contains('to-left') && intersectsLeft) {
                        tokens.replace('from-left', 'from-right');
                        tokens.replace('to-left', 'to-right');
                    } else if (tokens.contains('from-left') && intersectsRight) {
                        tokens.replace('from-left', 'from-right');
                        Array.from(tokens.entries()).forEach(entry => entry.indexOf('to-') === 0 && tokens.remove(entry));
                        tokens.add('to-left');
                    } else if (tokens.contains('from-center') && intersectsLeft) {
                        tokens.replace('from-center', 'from-left');
                        Array.from(tokens.entries()).forEach(entry => entry.indexOf('to-') === 0 && tokens.remove(entry));
                        tokens.add('to-right');
                    } else if (tokens.contains('from-center') && intersectsRight) {
                        tokens.replace('from-center', 'from-right');
                        Array.from(tokens.entries()).forEach(entry => entry.indexOf('to-') === 0 && tokens.remove(entry));
                        tokens.add('to-left');
                    } else if (tokens.contains('from-right') && tokens.contains('to-right') && intersectsRight) {
                        tokens.replace('from-right', 'from-left');
                        tokens.replace('to-right', 'to-left');
                    } else if (tokens.contains('from-right') && intersectsRight) {
                        tokens.replace('from-right', 'from-left');
                        Array.from(tokens.entries()).forEach(entry => entry.indexOf('to-') === 0 && tokens.remove(entry));
                        tokens.add('to-right');
                    }
                }
                this.setAttribute('open', tokens.toString());
                this.style.setProperty('--drop-content-current-content-height', `${this.shadowRoot.querySelector('[part="content"]').scrollHeight}px`);
                this.dispatchEvent(new CustomEvent('open', {
                    bubbles: false,
                    cancelable: false
                }));
            }
            close() {
                if (!this.hasAttribute('open')) {
                    return;
                }
                this.removeAttribute('open');
                this.style.setProperty('--drop-content-current-content-height', '0px');
                this.dispatchEvent(new CustomEvent('close', {
                    bubbles: false,
                    cancelable: false
                }));
            }
        });
    }
});
